import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SlicePipe } from '@angular/common';

import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

import { Subject, takeUntil } from 'rxjs';

import { TranslateModule } from '@ngx-translate/core';

import { SwiperOptions } from 'swiper/types/swiper-options';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';
import { ETripCityInfoType } from 'src/app/core/enums/trip-planner-view.enum';

import { PackageService } from 'src/app/core/services/package.service';
import { HeaderStateService } from 'src/app/core/services/header-state.service';

import { ShowAllMobileComponent } from '../show-all-mobile/show-all-mobile.component';
import { NoItemsFoundComponent } from 'src/app/shared/components/no-items-found/no-items-found.component';
import { VoiceGuideCardMobileComponent } from '../voice-guide-card-mobile/voice-guide-card-mobile.component';

const VOICE_LIST_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoplay: {
    delay: 10_000,
  },
  breakpoints: {
    375: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    524: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1100: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-voice-guide-list-mobile',
  templateUrl: './voice-guide-list-mobile.component.html',
  styleUrls: ['voice-guide-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SwiperDirective,
    TranslateModule,
    SlicePipe,
    NoItemsFoundComponent,
    VoiceGuideCardMobileComponent,
  ],
})
export class VoiceGuideListMobileComponent implements OnInit, OnDestroy {
  @Input() isFetching: boolean = false;
  @Input() countryName: string = '';
  @Input() cityName: string = '';
  @Input() tours: any[] = [];

  protected readonly swiperOptions: SwiperOptions = VOICE_LIST_SWIPER_OPTIONS;

  private destroy$ = new Subject<void>();

  filters: MatBottomSheetRef<ShowAllMobileComponent> | null = null;

  constructor(
    protected headerStateService: HeaderStateService,
    private bottomSheet: MatBottomSheet,
    private packageService: PackageService,
  ) {}

  ngOnInit() {
    this.headerStateService.backBtnClickEmmit
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.filters) {
          this.headerStateService.isBackBtnPresent = false;
          this.filters.dismiss();
          this.filters = null;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public seeAll(e: MouseEvent): void {
    e.preventDefault();

    this.headerStateService.isBackBtnPresent = true;
    this.filters = this.bottomSheet.open(ShowAllMobileComponent, {
      hasBackdrop: false,
      closeOnNavigation: true,
      panelClass: ['custom-bottom-sheet', 'custom-bottom-sheet--filters'],
      data: {
        items: this.tours,
        pageType: ETripCityInfoType.VOICE_GUIDE,
        cityId: '',
        cityName: this.cityName,
        countryName: this.countryName,
        currentDestinationIndex: 0,
        packages$: this.packageService.packages$,
      },
    });
  }
}
